import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import{DashboardComponent} from './dashboard/dashboard.component';
import{ShoppingcartComponent} from './shoppingcart/shoppingcart.component';
import{OrderhistoryComponent} from './orderhistory/orderhistory.component'
import { NotificationsComponent } from './notifications/notifications.component';
import{LoginComponent} from './login/login.component'
import { ProfileComponent } from './profile/profile.component';
import { CurrentInventoryComponent } from './current-inventory/current-inventory.component';
import { MainviewComponent } from './mainview/mainview.component';
import { OpenordersComponent } from './openorders/openorders.component';
import { VendormastersComponent } from './vendormasters/vendormasters.component';
import { ForgetpasswordComponent } from './forgetpassword/forgetpassword.component';
import { MobileVerificationComponent } from './mobileverification/mobileverification.component';
import { EmailVerificationComponent } from './email-verification/email-verification.component';
import { ApprovalprimaryuserComponent } from './approvalprimaryuser/approvalprimaryuser.component';
import { ExportLogsComponent } from './exportlogs/exportlogs.component';
import { AdminusermanagementComponent } from './adminusermanagement/adminusermanagement.component';
import { RolemanagementComponent } from './rolemanagement/rolemanagement.component';
import { UsermanagmentComponent } from './usermanagment/usermanagment.component';
import { UseraccountmanagementComponent } from './useraccountmanagement/useraccountmanagement.component';
import { SavedListManagementComponent } from './saved-list-management/saved-list-management.component';
import { SystemlogsmanagementComponent } from './systemlogsmanagement/systemlogsmanagement.component';
import { PagecontentmanagementComponent } from './pagecontentmanagement/pagecontentmanagement.component';
import { BannermanagementComponent } from './bannermanagement/bannermanagement.component';
import { AppnotificationtextmanagementComponent } from './appnotificationtextmanagement/appnotificationtextmanagement.component';
import { AppnotificationmanagementComponent } from './appnotificationmanagement/appnotificationmanagement.component';
import { EmailnotificationttextmanagementComponent } from './emailnotificationttextmanagement/emailnotificationttextmanagement.component';
import { EmailnotificationmanagementComponent } from './emailnotificationmanagement/emailnotificationmanagement.component';
import { SmsnotificationtextmanagementComponent } from './smsnotificationtextmanagement/smsnotificationtextmanagement.component';
import { SmsnotificationmangementComponent } from './smsnotificationmangement/smsnotificationmangement.component';
import { ErrorComponent } from './error/error.component';
import { RouteGuardGuard } from './service/route-guard.guard';
import { EmailverificationenduserComponent } from './emailverificationenduser/emailverificationenduser.component';
import { ProductCategoryComponent } from './product-category/product-category.component';
import { ProductSubCategoryComponent } from './product-sub-category/product-sub-category.component';
import { SampleComponent } from './sample/sample.component';
import { ChangePasswordComponent } from './change-password/change-password.component'
import { VendoraccountmangementComponent } from './vendoraccountmangement/vendoraccountmangement.component';
import { VendorproductmanagementComponent } from './vendorproductmanagement/vendorproductmanagement.component';
import { OrdermanagementComponent } from './ordermanagement/ordermanagement.component';
import { AccountsManagementComponent } from './accounts-management/accounts-management.component'
import { BiddingmanagementComponent } from './biddingmanagement/biddingmanagement.component';
import { ReportsmanagementComponent } from './reportsmanagement/reportsmanagement.component';
import { GiveawaymanagementComponent } from './giveawaymanagement/giveawaymanagement.component';

const routes: Routes = [ {path:'forgetPassword',component:ForgetpasswordComponent},
{path:'verifyEmailAddress',component:EmailVerificationComponent},
{path:'verifyEmail/enduser',component:EmailverificationenduserComponent},

{path:'mobileverification',component:MobileVerificationComponent},
{ path:'sample', component:SampleComponent },

{path:'',component:LoginComponent},
{path:'403',component:ErrorComponent},

{ path:  'mainview', component:  MainviewComponent,children: [
  { path:'changePassword', component:ChangePasswordComponent, canActivate: [RouteGuardGuard] },
 { path:'dashboard', component:DashboardComponent, canActivate: [RouteGuardGuard] },
 { path:'admin', component:AdminusermanagementComponent, canActivate: [RouteGuardGuard] },
 { path:'userAccount', component:UseraccountmanagementComponent, canActivate: [RouteGuardGuard] },
 { path:'account', component:AccountsManagementComponent, canActivate: [RouteGuardGuard] },

 { path:'user', component:UsermanagmentComponent , canActivate: [RouteGuardGuard]},

 { path:'role', component:RolemanagementComponent , canActivate: [RouteGuardGuard]},
 { path:'category', component:ProductCategoryComponent },

 { path:'subCategory', component:ProductSubCategoryComponent },
 {path:'approvalPrimaryUser',component:ApprovalprimaryuserComponent, canActivate: [RouteGuardGuard]},

 {path:'shoppingCart',component:ShoppingcartComponent, canActivate: [RouteGuardGuard]},
 {path:'savedList',component:SavedListManagementComponent, canActivate: [RouteGuardGuard]},

 {path:'orderHistory',component:OrderhistoryComponent, canActivate: [RouteGuardGuard]},
 {path:'Notifications',component:NotificationsComponent, canActivate: [RouteGuardGuard]},
 {path:'openOrders',component:OpenordersComponent, canActivate: [RouteGuardGuard]},
 {path:'vendorMasters',component:VendormastersComponent, canActivate: [RouteGuardGuard]},
 {path:'vendorAccounts',component:VendoraccountmangementComponent, canActivate: [RouteGuardGuard]},
 {path:'vendorProductsmasters',component:VendorproductmanagementComponent, canActivate: [RouteGuardGuard]},
 {path:'ordermanagement',component:OrdermanagementComponent, canActivate: [RouteGuardGuard]},
  {path:'biddingManagement',component:BiddingmanagementComponent,canActivate:[RouteGuardGuard]},
  {path:'giveAwayManagement',component:GiveawaymanagementComponent,canActivate:[RouteGuardGuard]},

 {path:'systemLogs',component:SystemlogsmanagementComponent, canActivate: [RouteGuardGuard]},
 {path:'pageContent',component:PagecontentmanagementComponent, canActivate: [RouteGuardGuard]},
 {path:'appNotificationText',component:AppnotificationtextmanagementComponent, canActivate: [RouteGuardGuard]},
 {path:'appNotification',component:AppnotificationmanagementComponent, canActivate: [RouteGuardGuard]},
 {path:'emailNotificationText',component:EmailnotificationttextmanagementComponent, canActivate: [RouteGuardGuard]},
 {path:'emailNotification',component:EmailnotificationmanagementComponent, canActivate: [RouteGuardGuard]},
 {path:'smsNotificationText',component:SmsnotificationtextmanagementComponent, canActivate: [RouteGuardGuard]},
 {path:'smsNotification',component:SmsnotificationmangementComponent, canActivate: [RouteGuardGuard]},
 {path:'reports',component:ReportsmanagementComponent, canActivate: [RouteGuardGuard]},

 {path:'banner',component:BannermanagementComponent, canActivate: [RouteGuardGuard]},

 {path:'profile',component:ProfileComponent, canActivate: [RouteGuardGuard]},
 {path:'currentInventory',component:CurrentInventoryComponent, canActivate: [RouteGuardGuard]},
 {path:'exportLogs',component:ExportLogsComponent, canActivate: [RouteGuardGuard]},

]},

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
